import type { LessonType } from "@prisma/client";
import { lessonTypeAccentClass, modalityAccent } from "@lib/ui/modalityTints";

/** Hub cards accent by the skill they lead to; review cards get their own colour. */
const REVIEW_ACCENT = "border-l-4 border-lavender";

/** The "concept unlocked" celebration card gets the coral accent (UI-SPEC Surface 3). */
const UNLOCK_ACCENT = "border-l-4 border-coral";

export function lessonTypeAccent(type: LessonType | "LISTENING" | "REVIEW" | "UNLOCK"): string {
  if (type === "UNLOCK") return UNLOCK_ACCENT;
  if (type === "REVIEW") return REVIEW_ACCENT;
  if (type === "LISTENING") return modalityAccent("LISTENING");
  return lessonTypeAccentClass(type);
}
